var waitFor = require('../lib/waitFor');

waitFor('.landing-type', function() {

  var $productsContainer = $('.product-list-by-type'),
      $productResource = $productsContainer.find('.comp-product-resources'),
      $brandFilter = $('.product-brand-filter'),
      $filterAll = $('.all'),
      $filterAllInput = $('.all input'),
      getProductsVisibleCount = function() {
        // array for visible thumbnails with filter
        currentProductsVisible = [];

        // populate array with id number from thumbnails that have 'is-visible' class
        $('.comp-product-resources.is-visible').each(function() {
          currentProductsVisible.push($(this).data('id'))
        });

        // show count of how many items are visible
        $('.product-results-count span').html(currentProductsVisible.length);
      },
      getProductsByParameter = function() {
        var paramTypeId = getUrlParameter('typeid');

        if (paramTypeId != undefined) {
          // hide all products
          $productResource.hide().removeClass('is-visible');

          // remove all checked states from attributes
          $filterAllInput.removeAttr('checked');

          // enabled the all filter input
          $filterAllInput.attr('disabled', false);

          // only show products which have the parameter ID
          $('.product-list-by-type .comp-product-resources.' + paramTypeId).show().addClass('is-visible');

          // check the input box that has matching parameter ID
          $('.product-brand-filter input[rel="'+ paramTypeId +'"]').prop('checked', true);

          // run function to get count of visible products
          getProductsVisibleCount();
        }
      };


  // --------------------------------
  // get URL parameter
  // --------------------------------

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  };


  // --------------------------------
  // filter resource categories
  // --------------------------------

  $brandFilter.find('input').on('change', function(e) {
    var checkbox = $(e.target);
    var value = $(this).attr('rel');

    if (value == "all") {
      // if "All":
      // show all photo categories
      // remove any checked states from filter checkboxes
      // and disable "All" checkbox so it can't be unchecked
      $productResource.show().addClass('is-visible');
      $filterAllInput.prop('checked', true);
      $filterAllInput.attr('disabled', true);
      $filterAll.siblings('li').find('input').prop('checked', false);

    } else {
      // hide category groups
      // remove checked state from "All" & make sure it can be checked
      // only show the checked contaienr
      $productResource.hide().removeClass('is-visible');
      $filterAllInput.removeAttr('checked');
      $filterAllInput.attr('disabled', false);
      $brandFilter.find('input:checked').each(function () {
        $('.product-list-by-type .comp-product-resources.' + $(this).attr('rel')).show().addClass('is-visible');
      });
    }

    // run function to get count of visible products
    getProductsVisibleCount();
  });

  var init = function() {
    getProductsVisibleCount();
    getProductsByParameter();
  }

  init();

});
